import NewInquiry from '@/components/NewInquiry';

export default function InquiryTab() {
  return <NewInquiry isTabRoot />;
}
